<template>
	<div class="news-container">
		<Hrader @refreshTheStatus="refreshTheStatus" :idShwo="7"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/news/Maskgroup.png" style="width: 100%; height: auto" />
		</div>

		<div class="rectangle" style="margin-top: -10px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 卡券新闻</div>
				</div>
			</div>
		</div>

		<div class="main-content">
			<div class="news-section">
				<div class="latest-news-card">
					<div class="news-image-wrapper" @click="goNewsDetail(0)">
					<img src="@/assets/news/Group 2264.png" alt="最新新闻" class="news-image" />
				</div>
					<div class="news-list">
						<div v-for="(item, index) in newsList" :key="index" class="news-item" @click="viewNews(item)">
							<img src="@/assets/news/Union.png" class="news-dot" />
							<span class="news-title">{{ item.title }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="category-section">
				<div v-if="loading" class="loading-wrapper">
					<span class="loading-text">加载中...</span>
				</div>
				<div v-else-if="categories.length === 0" class="loading-wrapper">
					<span class="loading-text">暂无数据</span>
				</div>
				<div v-else class="category-grid">
					<div v-for="(category, index) in categories" :key="index" class="category-card"
						@click="viewCategory(category)">
						<div class="category-image-wrapper">
							<img :src="category.image" :alt="category.title" class="category-image" />
						</div>
						<div class="category-info">
							<div class="category-title">{{ category.title }}</div>
							<p class="category-description">{{ category.description }}</p>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="tags-section">
			<div class="tags-container">
				<div 
					v-for="(tag, index) in tags" 
					:key="index" 
					class="tag-item" 
					@click="filterByTag(tag.name)"
					:style="{ backgroundColor: tag.bgColor, color: tag.textColor }"
				>
					{{ tag.name }}
				</div>
			</div>
		</div>

		<Tabr></Tabr>
		<Customer></Customer>
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted
	} from 'vue';
	import Hrader from '@/components/header.vue';
	import Tabr from '@/components/tabrButton.vue';
	import Customer from '@/components/customer.vue';
	import { useRouter } from 'vue-router';
	import { cardNewsTypeList, cardNewsTagList, cardNewsArticlePage } from '@/utils/api.js';
	import { ElMessage } from 'element-plus';

	const router = useRouter();

	const loading = ref(false);
	const newsList = ref([]);

	const categories = ref([]);
	const tags = ref([]);

	const fetchNewsTypes = async () => {
		loading.value = true;
		try {
			const res = await cardNewsTypeList();
			if (res.code === 0 && res.data) {
				categories.value = res.data.map(item => ({
					id: item.id,
					title: item.mainTitle,
					description: item.subTitle,
					image: item.logo,
					navLogo: item.navLogo,
					sort: item.sort
				}));
			} else {
				ElMessage.error(res.msg || '获取新闻类型失败');
			}
		} catch (error) {
			console.error('获取新闻类型列表失败:', error);
			ElMessage.error('网络异常，请稍后重试');
		} finally {
			loading.value = false;
		}
	};

	const fetchNewsTags = async () => {
		try {
			const res = await cardNewsTagList();
			if (res.code === 0 && res.data) {
				tags.value = res.data.map(item => ({
					id: item.id,
					name: item.name,
					bgColor: item.bgColor,
					textColor: item.textColor
				}));
			} else {
				ElMessage.error(res.msg || '获取新闻标签失败');
			}
		} catch (error) {
			console.error('获取新闻标签列表失败:', error);
			ElMessage.error('网络异常，请稍后重试');
		}
	};

	const fetchNewsArticles = async () => {
		try {
			const res = await cardNewsArticlePage({ page: 1, size: 6 });
			if (res.code === 0 && res.data && res.data.list) {
				newsList.value = res.data.list.map(item => ({
					id: item.id,
					title: item.title,
					categoryId: item.typeId || 0
				}));
			} else {
				ElMessage.error(res.msg || '获取新闻文章失败');
			}
		} catch (error) {
			console.error('获取新闻文章列表失败:', error);
			ElMessage.error('网络异常，请稍后重试');
		}
	};

	const refreshTheStatus = () => {
		let information = localStorage.getItem('information');
		console.log('refreshed:', information);
	};

	const goNewsDetail = (categoryIndex) => {
		router.push({ path: '/newsDetail', query: { categoryId: categoryIndex } });
	};

	const viewNews = (item) => {
		router.push({ 
			path: '/articleDetail', 
			query: { 
				articleId: item.id,
				categoryId: item.categoryId || 0 
			} 
		});
	};

	const viewCategory = (category) => {
		router.push({ path: '/newsDetail', query: { categoryId: category.id } });
	};

	const filterByTag = (tagName) => {
		const tag = tags.value.find(t => t.name === tagName);
		if (tag && tag.id !== undefined) {
			router.push({ 
				path: '/newsDetail', 
				query: { 
					tagId: tag.id,
					tagName: tag.name
				} 
			});
		} else {
			console.log('Tag not found or has no id:', tagName);
		}
	};

	onMounted(() => {
		fetchNewsTypes();
		fetchNewsTags();
		fetchNewsArticles();
	});
</script>

<style lang="scss" scoped>
	.news-container {
		min-height: 100vh;
		background-color: #f5f5f5;
	}

	.rectangle {
		width: 100%;
		height: 52px;
		background: #ffffff;
		border-radius: 0px 0px 0px 0px;
	}

	.rectangle-with {
		width: 1280px;
		margin: auto;
		height: 52px;
	}

	.flex-rectange {
		display: flex;
		align-items: center;
		height: 52px;
		margin-left: 22px;
	}

	.current-recy {
		margin-left: 7px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}

	.main-content {
		max-width: 1280px;
		margin: 0 auto;
		padding: 20px;
	}

	.news-section {
		margin-bottom: 18px;
	}

	.latest-news-card {
		background: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		display: flex;
		padding: 18px;
	}

	.news-image-wrapper {
		width: 441px;
		height: 189px;
		flex-shrink: 0;
	}

	.news-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.news-list {
		flex: 1;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(3, 1fr);
		gap: 15px 60px;
		padding: 15px;
	}

	.news-item {
		display: flex;
		align-items: center;
		cursor: pointer;
		transition: all 0.3s;
		max-width: 360px;
	}

	.news-item:hover {
		opacity: 0.8;
	}

	.news-dot {
		width: 17px;
		height: 20px;
		margin-right: 12px;
		flex-shrink: 0;
		object-fit: contain;
	}

	.news-title {
		font-family: 'PingFang SC', sans-serif;
		font-size: 18px;
		color: #333333;
		line-height: 1.4;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.category-section {
		margin-bottom: 30px;
	}

	.loading-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 200px;
		background: #ffffff;
		border-radius: 8px;
	}

	.loading-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #999999;
	}

	.category-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
	}

	.category-card {
		background: #ffffff;
		border-radius: 8px;
		overflow: hidden;
		cursor: pointer;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		padding: 18px;
	}

	.category-card:hover {
		transform: translateY(-3px);
		box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
	}

	.category-image-wrapper {
		width: 100%;
		height: 277px;
		overflow: hidden;
	}

	.category-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	.category-info {
		margin-top: 20px;
	}

	.category-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #333333;
		margin-bottom: 10px;
	}

	.category-description {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	line-height: 1.5;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	margin: 0;
}

	.tags-section {
		background: #fff;
		padding: 20px;
		margin: 0;
		transform: translateY(28px);
	}

	.tags-container {
		display: flex;
		flex-wrap: wrap;
		gap: 14px;
		max-width: 1280px;
		margin: 0 auto;
	}

	.tag-item {
		background: rgba(255, 245, 245, 1);
		color: rgba(236, 57, 57, 1);
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		padding: 8px 20px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.tag-item:hover {
		background: rgba(236, 57, 57, 1);
		color: #fff;
	}

	@media (max-width: 992px) {
		.banner-section {
			flex-direction: column;
			text-align: center;
			padding: 40px 20px;
		}

		.banner-icon {
			margin-top: 20px;
		}

		.latest-news-card {
			flex-direction: column;
		}

		.news-image-wrapper {
			width: 100%;
			height: 200px;
		}

		.category-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media (max-width: 768px) {
		.banner-title {
			font-size: 24px;
		}

		.category-grid {
			grid-template-columns: 1fr;
		}

		.breadcrumb {
			flex-wrap: wrap;
		}
	}
</style>